import type {
  InsightsLabV2Favorite,
  InsightsLabV2Report,
} from 'api/insightsLabV2'
import ModalContainer from 'components/ModalContainer'
import { buildTranslate } from 'locales'
import React from 'react'
import ReportBrowser from './ReportBrowser'

const t = buildTranslate('insights_lab_v2.picker')

type Props = {
  isOpen: boolean
  onClose: () => void
  reports: InsightsLabV2Report[]
  favorites: InsightsLabV2Favorite[]
  onOpenReport: (report: InsightsLabV2Report) => void
  onOpenFavorite: (favorite: InsightsLabV2Favorite) => void
  onDeleteFavorite: (id: number) => void
}

// "See all reports" modal — used while a report is already open. The browser
// body is shared with the inline empty state (ReportBrowser).
const ReportPickerModal = ({
  isOpen,
  onClose,
  reports,
  favorites,
  onOpenReport,
  onOpenFavorite,
  onDeleteFavorite,
}: Props): JSX.Element => (
  <ModalContainer
    isOpen={isOpen}
    onClose={onClose}
    title={t('title')}
    hideCancel
    showBottomProceed={false}
    width="1200px"
    dialogStyle={{ maxWidth: '95vw' }}
  >
    <ReportBrowser
      reports={reports}
      favorites={favorites}
      onOpenReport={onOpenReport}
      onOpenFavorite={onOpenFavorite}
      onDeleteFavorite={onDeleteFavorite}
    />
  </ModalContainer>
)

export default ReportPickerModal
